export const apiFetch = async (url, options = {}) => {
  const response = await fetch(`${process.env.REACT_APP_API_URL}${url}`, {
    ...options,
    credentials: "include",
    headers: {
      "Content-Type": "application/json",
      ...(options.headers || {}),
    },
  });

  if (response.status === 401) {
    window.dispatchEvent(new CustomEvent("recruitglance:session-expired"));
  }

  if (response.status === 403) {
    try {
      const data = await response.clone().json();
      const detail = data?.detail || "";
      if (
        typeof detail === "string" &&
        (detail.includes("account is inactive") || detail.includes("Pilot access may have ended"))
      ) {
        window.dispatchEvent(new CustomEvent("recruitglance:session-expired", { detail }));
      }
    } catch (err) {
      // Keep the original response available to the caller.
    }
  }

  return response;
};
